<template>
  <div class="g-wrapper g-vertical-block">
    <div class="c-document g-main-wrapper">
      <div class="search-form">
        <ElForm inline class="elementui-common-form-styles" v-highlight>
          <ElFormItem label="用户名">
            <ElInput v-model.trim="queryForm.name" clearable @keyup.enter.native="onQueryAction()">
              <i slot="append" @click="onQueryAction()" class="el-icon-search"></i>
            </ElInput>
          </ElFormItem>

          <ElFormItem label="状态">
            <el-select v-model="queryForm.status" @change="onQueryAction()" filterable clearable placeholder="全部" style="width: 110px">
              <el-option v-for="item in ACCOUNT_STATUS" :key="item.value" :label="item.label" :value="item.value"> </el-option>
            </el-select>
          </ElFormItem>

          <ElFormItem class="bg-transparent">
            <ElButton type="primary" @click="onQueryAction()">查询</ElButton>
            <span>&emsp;</span>
            <el-tooltip effect="dark" placement="top">
              <div slot="content">
                <p>代投登录地址：https://tfdata.caohua.com/</p>
              </div>
              <span class="el-icon-info"> </span>
            </el-tooltip>
          </ElFormItem>
        </ElForm>

        <div class="opt-btns">
          <el-button type="primary" @click="showAddFormModal">创建代投账号</el-button>
        </div>
      </div>

      <Viewport v-model="tableHeight">
        <el-table
          v-loading="tableLoading"
          style="width: 100%"
          :data="tableData"
          :height="tableHeight"
          class="common-el-table-styles"
          border
          stripe
        >
          <el-table-column
            v-for="(col, id) in tableCols"
            :key="id"
            :prop="col.key"
            :label="col.title"
            :width="col.width"
            show-overflow-tooltip
          >
          </el-table-column>

          <el-table-column label="操作" width="90">
            <template slot-scope="{ row }">
              <el-button type="text" @click="onUpdateAction(row)">编辑</el-button>
              <el-button type="text" @click="onRowStatusToggleAction(row)">{{ row.status === 1 ? '禁用' : '启用' }}</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="pager">
          <el-pagination
            :total="total"
            :current-page.sync="pager.pageIndex"
            :page-size.sync="pager.pageSize"
            :page-sizes="[10, 30, 50, 100]"
            layout="total, sizes, prev, pager, next, jumper"
            @current-change="onQueryAction"
            @size-change="onSizeChange"
            class="pager"
            background
          />
        </div>
      </Viewport>
    </div>
    <el-dialog title="代投账号管理" :visible.sync="addFormVisible" :close-on-click-modal="false" width="580px" @close="onAccountAddCancel">
      <el-dialog width="860px" :title="authListTitle" :close-on-click-modal="false" :visible.sync="authItemsModalVisible" append-to-body>
        <div style="text-align: right">
          <el-button type="text" @click="checkAllAuthItems(true)">全部勾选</el-button>
          <el-button type="text" @click="checkAllAuthItems(false)">取消勾选</el-button>
        </div>

        <div class="auth-row" v-for="(item, index) in authList" :key="index">
          <h3>
            {{ item.name }}
            <el-tooltip v-if="item.name === '中间件_再归因维度数据'" effect="dark" placement="top">
              <div slot="content" style="width: 420px">
                <div style="line-height: 20px">
                  <p style="font-weight: 700">说明：</p>
                  <p>
                    1、【中间件_再归因】纬度的数据，计算的是整个中间件游戏下，第1次创角在哪个包，则后续所有的收入会归于首次创角的包体及计划里面。并且用户在流失XX天（后台设置的时间，一般设置30天）后，也会重新回归计算。
                  </p>
                  <p>2、建议外放CPS渠道用该指标进行结算。</p>
                  <p style="margin-top: 10px; font-weight: 700">3、字段说明： 这里的中间件都是指【中间件_再归因】的数据</p>
                  <p>
                    1）、创角总流水（中间件）：在中间件纬度归属该计划的所有创角用户，在所选时间范围内的充值金额（包括所选时间范围内的新老用户），对于后续流失XX天后再回归的用户也会进行统计计算流水。
                    <br />
                    2）、激活数/注册数/创角数(中间件）：在中间件纬度归属该计划的所有创角用户，在所选时间范围内的激活/注册/创角数，对于后续流失XX天后再回归的用户也会进行统计计算。<br />
                    3）、创角成本（中间件）：实际消耗/创角数（中间件）*100%；<br />
                    4）、新增付费创角数（中间件）：在中间件纬度归属该计划的所有创角用户，在所选时间范围内的新增付费创角数，对于后续流失XX天后再回归的用户也会进行统计计算。<br />
                    5）、新创角充值金额（中间件）：在中间件纬度归属该计划的所有创角用户，在所选时间范围内的新增付费创角的充值，对于后续流失XX天后再回归的用户也会进行统计计算。<br />
                    6)新创角回款率（中间件）=新创角充值金额（中间件）/实际消耗*100%
                  </p>
                </div>
              </div>
              <span class="el-icon-info"> </span>
            </el-tooltip>
          </h3>
          <div class="auth-check-item">
            <el-checkbox v-for="child in item.items" :key="child.key" :disabled="child.disabled" v-model="child.checked">
              {{ child.name }}
            </el-checkbox>
          </div>
        </div>
        <div class="auth-footer">
          <el-button @click="authListModalCancel">取消</el-button>
          <el-button type="primary" @click="authListModalConfirm">确定</el-button>
        </div>
      </el-dialog>

      <el-form class="add-form" label-width="130px" :model="addForm" :rules="addFormRules" ref="addFormRef">
        <el-form-item label="账号名称" prop="name">
          <el-input v-model="addForm.name" :disabled="!!addForm.id" placeholder="请输入用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="addForm.password" placeholder="请输入密码"></el-input>
        </el-form-item>

        <el-form-item label="页面权限" prop="pageAuth">
          <el-checkbox-group v-model="addForm.pageAuth">
            <el-checkbox label="M20984">追踪计划权限</el-checkbox>
            <el-checkbox label="M20334">投放计划明细数据</el-checkbox>
            <el-checkbox label="M20997">综合数据报表</el-checkbox>
            <el-checkbox label="M21265">推广数据（用于显示代投扣量录入数据）</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="明细数据权限" prop="privilege">
          <el-button type="text" @click="showPtomDetailAuthModal">+添加</el-button>
          <p class="auth-checked-items">{{ authCheckListText.ptomDetails }}</p>
        </el-form-item>
        <el-form-item label="综合数据报表" prop="privilege">
          <el-button type="text" @click="showComplexReportAuthModal">+添加</el-button>
          <p class="auth-checked-items">{{ authCheckListText.complextReport }}</p>
        </el-form-item>

        <el-form-item label="推广数据" prop="privilege">
          <el-button type="text" @click="showPromotionAuthModal">+添加</el-button>
          <p class="auth-checked-items">{{ authCheckListText.promotion }}</p>
        </el-form-item>

        <el-form-item label="扣量开关" prop="deductSwitch">
          <el-switch v-model="addForm.deductSwitch"></el-switch>
          <el-tooltip effect="dark" placement="top">
            <div slot="content" style="width: 420px">
              <div style="line-height: 20px">
                <p style="font-weight: 700">扣量说明：</p>
                <p>
                  1、设置扣量比例时，代投系统的【投放明细数据】和
                  <span>【综合数据报表】</span>
                  激活、注册、创角、新增角色数、新增付费创角数、当日新增付费设备、激活数（中间件）、注册数（中间件）、创角数（中间件）、新增付费创角数（中间件）对应的值，需要扣量。页面上面显示的数值=XX字段数值*（1-扣量比例），数值计算完<span
                    style="color: red"
                    >四舍五入.</span
                  >
                </p>
                <p>2、其他跟以上字段有计算关系的数据，都需要按照实际进行计算，例如激活成本=实际消耗/扣量后的激活。</p>
              </div>
            </div>
            <span class="el-icon-info"> </span>
          </el-tooltip>
        </el-form-item>

        <el-form-item label="扣量比例（%）" prop="ratio" v-if="addForm.deductSwitch">
          <el-input v-model="addForm.ratio"></el-input>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" rows="5" v-model="addForm.remark"></el-input>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="onAccountAddCancel">取 消</el-button>
        <el-button type="primary" :loading="addFormSubmitLoading" @click="onAccountAddConfirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useAddForm, useTable } from './hooks/useAgentAccountManage.js'
import { ACCOUNT_STATUS, tableCols } from './consts/data.js'
const tableHeight = ref(330)
const queryForm = ref({ name: '', status: '' })

const { tableData, tableLoading, total, pager, onQueryAction, getTableData, onSizeChange, onRowStatusToggleAction } = useTable(queryForm)

const {
  addFormVisible,
  authItemsModalVisible,
  addFormSubmitLoading,
  addFormRef,
  authListTitle,
  authList,
  addFormRules,
  addForm,
  ptomDetailAuthList,
  ptomDetailAuthCheckList,
  complexReportAuthCheckList,
  authCheckListText,
  showAddFormModal,
  showPtomDetailAuthModal,
  showComplexReportAuthModal,
  showPromotionAuthModal,
  authListModalConfirm,
  authListModalCancel,
  checkAllAuthItems,
  onAccountAddConfirm,
  onAccountAddCancel,
  onUpdateAction
} = useAddForm(getTableData)

onQueryAction()
</script>

<style scoped lang="scss">
.search-form {
  padding-top: 8px;
  display: flex;
  justify-content: space-between;
}

.add-form {
  max-height: 480px;
  overflow: auto;
  padding-right: 10px;
  .auth-checked-items {
    font-size: 12px;
    line-height: 20px;
  }
}

.auth-footer {
  text-align: right;
}
.auth-row {
  margin-bottom: 20px;

  .auth-check-item {
    display: flex;
    flex-wrap: wrap;

    .el-checkbox {
      width: 160px;
    }
  }
}
.pager {
  text-align: right;
}
</style>
